var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiniTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_255",
    "data-name": "Group 255",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.598,
    height: 13.489,
    viewBox: "0 0 16.598 13.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M653.02,209.463a6.83,6.83,0,0,1-2.161.827,3.408,3.408,0,0,0-5.8,3.106,9.661,9.661,0,0,1-7.018-3.559,3.41,3.41,0,0,0,1.053,4.547,3.4,3.4,0,0,1-1.543-.426,3.409,3.409,0,0,0,2.731,3.382,3.4,3.4,0,0,1-1.537.058,3.405,3.405,0,0,0,3.181,2.365,6.845,6.845,0,0,1-5.042,1.409,9.684,9.684,0,0,0,14.9-8.6,6.888,6.888,0,0,0,1.7-1.762,6.806,6.806,0,0,1-1.955.536A3.412,3.412,0,0,0,653.02,209.463Z",
    transform: "translate(-636.881 -209.214)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniTwitter);
export default __webpack_public_path__ + "static/media/mini-twitter.084b7719402df5a0c1a8f892cffe67b6.svg";
export { ForwardRef as ReactComponent };